export enum EmailFormat {
  Invoice = 'invoice',
  Summary = 'summary',
}
